import { render, staticRenderFns } from "./SerahTerima.vue?vue&type=template&id=f4dd540e&"
import script from "./SerahTerima.vue?vue&type=script&lang=js&"
export * from "./SerahTerima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports